import React from 'react'
import {createSearchParams, Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import PublicSecureAuthorization
    from "../../../../../services/system/secure-authorization/secure-authorization-controller";
import TableHeader from "../../../../../components/TableHeader";
import LinkPlus from "../../../../../components/Link/LinkPlus";
import Pagination from "../../../../../components/Pagination";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class DetailBusReportManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDate: null,
            content: "",
            listGroupUser: [],
            listPointBus: [],
            listData: [],
            pageNumber: 0,
            pageSize: 10,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Loại dịch vụ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Điểm đón",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Thời gian Đón/Trả",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],

            "autoGenCode": true,
            "bietBoi": false,
            "birthday": null,
            "birthdayFather": null,
            "birthdayGiamHo": null,
            "birthdayMother": null,
            "cheDoChinhSach": "CHE_DO_CHINH_SACH_1",
            "cheDoHoTro": "CHE_DO_HO_TRO_1",
            "choO": "TRONG_TRUONG",
            "code": "",
            "currentClassRoomId": 0,
            "dangDay": null,
            "dangVien": false,
            "dienHocSinh": "DIEN_HOC_SINH_1",

            "doanDay": null,
            "doanVien": false,
            "doiDay": null,
            "doiTuongUuTien": "UU_TIEN_1",
            "doiVien": false,
            "email": "",
            "ethnic": "KINH",
            "fatherDanToc": false,
            "fullName": "",
            "fullNameFather": "",
            "fullNameGiamHo": "",
            "fullNameMother": "",
            "gender": "MALE",
            "gradeId": "",
            "heHocNN": "TIENG_ANH",
            "hinhThuc": "TRUNG_TUYEN",
            "identify": "",
            "ishocTruongTrinhGDBo": true,
            "iskhuyetTat": false,
            "jobFather": "",
            "jobGiamHo": "",
            "jobMother": "",
            "khuyetTat": "KHUYET_TAT_1",
            "mailFather": "",
            "mailGiamHo": "",
            "mailMother": "",
            "motherDanToc": false,
            "nhomMau": "NHOM_MAU_1",
            "noiSinh": "",
            "phone": "",
            "phoneFather": "",
            "phoneGiamHo": "",
            "phoneHome": "",
            "phoneMother": "",
            "pointDegree": "TRUNG_BINH",
            "queQuan": "",
            "religion": "NO",
            "schoolDay":null,
            "sodangbo": "",
            "state": "CHUA_PHANLOP",
            "taiDinhCu": false,
            "tamTru": "",
            "tengoiEthnnic": "",
            "thanhPhanParent": "THANH_PHAN_PARENT_1",
            "thuongTru": "",
            "address": "",
            "wardCode": "",
            "provinceCode": "",
            "districtCode": "",
            yearId: parseInt(getSchoolYear()),
            "zone": "",
            listClassRoom: [],
        };
    }

    componentWillMount() {
        this.getAllClass()
        this.getListGroupUser()
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderStatus() {
        let listStatus = [
            {
                "id": "All",
                "name": "Tất cả"
            },
            {
                "id": "PENDING",
                "name": "Chưa thanh toán"
            },
            {
                "id": "PAYMENT",
                "name": "Đã thánh toán"
            },

        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onCreate = () => {
        let {fullName} = this.state;
        if (fullName == "" || fullName.length < 5){
            toast.error("Tên học sinh phải lớn hơn 6 ký tự");
        }else if(this.state.gradeId == ""){
            toast.error("Vui lòng chọn khối học");
        }else if(this.state.address == "" || this.state.wardId == undefined || this.state.provinceId==undefined || this.state.districtId == undefined){
            toast.error("Vui lòng nhập địa chỉ học sinh");
        }else if (!(this.state.fullNameFather !== "" && this.state.birthdayFather !== "" && this.state.jobFather !== ""  && this.state.phoneFather !== ""  && this.state.mailFather !== "") &&
            !(this.state.fullNameMother !== "" && this.state.birthdayMother !== "" && this.state.jobMother !== ""  && this.state.phoneMother !== ""  && this.state.mailMother !== "") &&
            !(this.state.fullNameGiamHo !== "" && this.state.birthdayGiamHo !== "" && this.state.jobGiamHo !== ""  && this.state.phoneGiamHo !== ""  && this.state.mailGiamHo !== "")
        ) {
            toast.error("Vui lòng nhập đủ thông tin của ít nhất 1 người(Bố hoặc mẹ hoặc người giám hộ");
        }else {
            let payload = {
                "autoGenCode": this.state.autoGenCode,
                "bietBoi": this.state.bietBoi,
                "birthday": this.state.birthday,
                "birthdayFather": this.state.birthdayFather,
                "birthdayGiamHo": this.state.birthdayGiamHo,
                "birthdayMother": this.state.birthdayMother,
                "cheDoChinhSach": this.state.cheDoChinhSach,
                "cheDoHoTro": this.state.cheDoHoTro,
                "choO": this.state.choO,
                "code": this.state.code,
                "currentClassRoomId": parseInt(this.state.currentClassRoomId),
                "dangDay": this.state.dangDay,
                "dangVien":  this.state.dangVien,
                "dienHocSinh": this.state.dienHocSinh,
                "districtCode": this.state.districtId,
                "doanDay": this.state.doanDay,
                "doanVien": this.state.doanVien,
                "doiDay": this.state.doiDay,
                "doiTuongUuTien": this.state.doiTuongUuTien,
                "doiVien": this.state.doiVien,
                "email": this.state.email,
                "ethnic": this.state.ethnic,
                "fatherDanToc":  this.state.fatherDanToc,
                "fullName": this.state.fullName,
                "fullNameFather":this.state.fullNameFather,
                "fullNameGiamHo": this.state.fullNameGiamHo,
                "fullNameMother": this.state.fullNameMother,
                "gender": this.state.gender,
                "grade": this.state.gradeId,
                "heHocNN": this.state.heHocNN,
                "hinhThuc": this.state.hinhThuc,
                "identify": this.state.identify,
                "ishocTruongTrinhGDBo": this.state.ishocTruongTrinhGDBo,
                "iskhuyetTat": this.state.iskhuyetTat,
                "jobFather": this.state.jobFather,
                "jobGiamHo": this.state.jobGiamHo,
                "jobMother": this.state.jobMother,
                "khuyetTat": this.state.khuyetTat,
                "mailFather": this.state.mailFather,
                "mailGiamHo": this.state.mailGiamHo,
                "mailMother": this.state.mailMother,
                "motherDanToc": this.state.motherDanToc,
                "nhomMau": this.state.nhomMau,
                "noiSinh": this.state.noiSinh,
                "phone": this.state.phone,
                "phoneFather": this.state.phoneFather,
                "phoneGiamHo": this.state.phoneGiamHo,
                "phoneHome": this.state.phoneHome,
                "phoneMother":this.state.phoneMother,
                "pointDegree": this.state.pointDegree,
                "provinceCode": this.state.provinceId,
                "queQuan": this.state.queQuan,
                "religion": this.state.religion,
                "schoolDay": this.state.schoolDay,
                "sodangbo": this.state.sodangbo,
                "state": this.state.state,
                "taiDinhCu": this.state.taiDinhCu,
                "tamTru": this.state.address,
                "tengoiEthnnic": this.state.tengoiEthnnic,
                "thanhPhanParent": this.state.thanhPhanParent,
                "thuongTru": this.state.thuongTru,
                "wardCode": this.state.wardId,
                "yearId": parseInt(getSchoolYear()),
                "zone": this.state.zone
            }
            StudentController.create(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-thong-tin-hoc-sinh');
                    toast.success("Tạo học sinh thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };

    render() {
        let {gradeId, address, wardId, listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="report-bus" parentClass="bus-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Báo cáo điểm danh xe bus"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Báo cáo điểm danh xe bus ngày 27/02/2023</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin tuyến xe bus
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên tuyến xe bus</label>
                                                <label className="col-8 label-item pl-0">Tuyến xe xịn</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tài xế xe bus</label>
                                                <label className="col-8 label-item pl-0">Tuyến xe xịn</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phụ xe 1</label>
                                                <label className="col-8 label-item pl-0">Tuyến xe xịn</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phụ xe 2</label>
                                                <label className="col-8 label-item pl-0">Tuyến xe xịn</label>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổng số chỗ</label>
                                                <label className="col-8 label-item pl-0"><b>40/50</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổng số H/S đón</label>
                                                <label className="col-8 label-item pl-0"><b>30/40</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổng số H/S trả</label>
                                                <label className="col-8 label-item pl-0"><b>30/40</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thời gian bắt đầu đón:</label>
                                                <label className="col-8 label-item pl-0"><b>10:12</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thời gian kết thúc đón:</label>
                                                <label className="col-8 label-item pl-0"><b>11: 12</b></label>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thời gian bắt đầu trả:</label>
                                                <label className="col-8 label-item pl-0"><b>10:12</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thời gian kết thúc trả:</label>
                                                <label className="col-8 label-item pl-0"><b>11: 12</b></label>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách học sinh đã đón/trả
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2 mb-3">
                                                <label className="label-item col-4">Chọn điểm đón xe bus</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.status}
                                                    onChange={(e) => {
                                                        this.state.status = e.target.value;
                                                        this.setState({
                                                            status: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="D">Điểm đón 1</option>
                                                    <option value="D">Điểm đón 2</option>
                                                    <option value="D">Điểm đón 3</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2 mb-3">
                                                <label className="label-item col-4">Hình thức</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.status}
                                                    onChange={(e) => {
                                                        this.state.status = e.target.value;
                                                        this.setState({
                                                            status: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="D">Đón</option>
                                                    <option value="D">Trả</option>
                                                </select>
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                        let a = "";
                                                                        let descend = "";
                                                                        if (data.sortAsc == null) {
                                                                            // a = "id=asc";
                                                                            a = "id";
                                                                            descend = 'DESC'
                                                                        } else {
                                                                            a = data.sortId;
                                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                                        }
                                                                        this.setState(
                                                                            {
                                                                                sort: a,
                                                                                descending: descend
                                                                            },
                                                                            () => this.getListStudent()
                                                                        );
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!this.state.listData ||
                                                                this.state.listData.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listData &&
                                                                        listData.length > 0 &&
                                                                        listData?.map((row, index) => (
                                                                            <tr style={{height: 50}}>
                                                                                <td style={{textAlign: "center"}} scope="row">
                                                                                    {" "}
                                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                                        index +
                                                                                        1}
                                                                                </td>
                                                                                <td style={{textAlign: "left"}} scope="row">
                                                                                    {row.fullName}
                                                                                </td>
                                                                                <td style={{textAlign: "left"}} scope="row">
                                                                                    {row.birthday ? moment(row.birthday).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                                                </td>
                                                                                <td style={{textAlign: "center"}}>
                                                                                    {row.gender == "MALE"?"Nam": "Nữ"}
                                                                                </td>
                                                                                <td style={{textAlign: "left"}}>
                                                                                    {row.state}
                                                                                </td>
                                                                                <td style={{textAlign: "center"}}>
                                                                                    <LinkPlus
                                                                                        style={{color: '#000'}}
                                                                                        to={{
                                                                                            pathname: "/ad-sas-school/sua-ho-so-hoc-sinh",
                                                                                            search: createSearchParams({
                                                                                                id: `${row.id}`
                                                                                            }).toString(),
                                                                                            state: {
                                                                                                fromDashboard: true,
                                                                                                id: row.id
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <button className="btn btn-action p-2"
                                                                                                title='Sửa'
                                                                                                style={{cursor: 'pointer'}}
                                                                                        >
                                                                                            <i className="ti-pencil-alt"/>
                                                                                        </button>
                                                                                    </LinkPlus>
                                                                                    <button className="btn btn-action p-2"
                                                                                            title='Xóa'
                                                                                            style={{cursor: 'pointer'}}
                                                                                            onClick={() => {
                                                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                                                            }}
                                                                                    >
                                                                                        <i className="ti-trash"/>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumber}
                                                            itemsCountPerPage={this.state.pageSize}
                                                            totalItemsCount={this.state.totalItem}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-thong-bao"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(DetailBusReportManagement)